module.exports = __webpack_public_path__ + "static/img/pic_cprtrauma.b59347ba.png";